import { render, staticRenderFns } from "./ArticleTradeStatsSummary.vue?vue&type=template&id=29e53000&"
import script from "./ArticleTradeStatsSummary.vue?vue&type=script&lang=js&"
export * from "./ArticleTradeStatsSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports